export const STORE_APPSETTING_FILE = "STORE_APPSETTING_FILE";
export const STORE_TOKEN = "STORE_TOKEN";
